"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Divider = require("../../Divider");

var _FoldableCard = _interopRequireDefault(require("../FoldableCard/FoldableCard"));

var _CampaignSummary = _interopRequireDefault(require("./CampaignSummary"));

var CampaignCard = function CampaignCard(_ref) {
  var campaign = _ref.campaign,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
      children = _ref.children;
  var onCardClickHandler = (0, _react.useCallback)(function () {
    return onSelect(campaign.id);
  }, [campaign, onSelect]);
  return /*#__PURE__*/_react["default"].createElement(_FoldableCard["default"], {
    summaryComponent: /*#__PURE__*/_react["default"].createElement(_CampaignSummary["default"], {
      name: campaign.name,
      teamName: campaign.team.name,
      campaignId: campaign.id,
      isActive: isSelected
    }),
    isActive: isSelected,
    onClick: onCardClickHandler
  }, /*#__PURE__*/_react["default"].createElement(_Divider.AlyceDivider, {
    ml: 1,
    mt: 0.375,
    mb: 1.25,
    color: "dividerLight",
    shift: 3
  }), children);
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignCard);

exports["default"] = _default;